import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-custom-norm-value-column-molecule',
  templateUrl: './custom-norm-value-column-molecule.component.html',
  styleUrls: ['./custom-norm-value-column-molecule.component.scss']
})
export class CustomNormValueColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
  @Input() dynamicNormForm: FormGroup;
  @Output() dataEmitForDynamicNormReview = new EventEmitter<{}>();

  action(actionType, controlId) {
    if (actionType === "update") {
      this.dataEmitForDynamicNormReview.emit({
        status: "MODIFIED",
        id: controlId,
        newNormValue: this.dynamicNormForm.get(controlId).value,
      });
    } else {
      this.dataEmitForDynamicNormReview.emit({
        status: actionType,
        id: controlId,
      });
    }
  }
}
